export default __webpack_public_path__ + "static/media/1inch-exchange.63c8e698.jpg";